import React, { useCallback, useEffect, useState } from "react";
import { initRequestES } from "../../shared/common/learnositySpanishAuthorInit";
import { getRequest } from "../../../api/user.service";

export default function EditorPageES(props: any) {
  let authorAppES;

  const [firstReady, setFirstReady] = useState(false);
  const [initializedIndexes, setInitializedIndexes] = useState<number[]>([]);

  const initializeLearnosityInstance = useCallback(
    async (elementId, index, authorApp, isFirstCall: boolean) => {
      authorApp = isFirstCall ? authorAppES : authorApp;
      const callbacksES = {
        readyListener: await async function () {
          await authorApp.on("render:item", async function () {
            props.authorAppParentES(authorApp);
            const questions = authorApp.getItem().questions;
            if (questions.length == 0) {
              if (props.isSubTypeChanged) {
                const questionData =
                  props.spanishWidgetDataArray[props.addSpanishQuestionIndex] ??
                  props.englishWidgetDataArray[props.addSpanishQuestionIndex];

                await authorApp.setWidget(questionData, props.payloadLabel);
                if (
                  props.spanishWidgetDataArray[props.addSpanishQuestionIndex]
                ) {
                  props.spanishWidgetDataArray[props.addSpanishQuestionIndex] =
                    questionData;
                  props.setSpanishWidgetDataArray(props.spanishWidgetDataArray);
                } else {
                  props.spanishWidgetDataArray.push(questionData);
                  props.setSpanishWidgetDataArray([
                    ...props.spanishWidgetDataArray,
                  ]);
                }
                if (props.arr.length > 0) {
                  if (props.addSpanishQuestionIndex === props.arr.length)
                    props.setSubTypeChanged(false);
                } else {
                  props.setSubTypeChanged(false);
                }
              } else {
                if (
                  props.spanishWidgetDataArray.length == 0 ||
                  !props.spanishWidgetDataArray[props.addSpanishQuestionIndex]
                ) {
                  const questionData =
                    props.englishWidgetDataArray[props.addSpanishQuestionIndex];

                  await authorApp.setWidget(questionData, props.payloadLabel);
                  props.spanishWidgetDataArray.push(questionData);
                  props.setSpanishWidgetDataArray([
                    ...props.spanishWidgetDataArray,
                  ]);
                } else {
                  const questionData =
                    props.spanishWidgetDataArray[props.addSpanishQuestionIndex];

                  authorApp.setWidget(questionData, props.payloadLabel);
                }
              }
            } else {
              if (props.isSubTypeChanged) {
                const questionData =
                  props.englishWidgetDataArray[props.addSpanishQuestionIndex];
                await authorApp.setWidget(questionData, props.payloadLabel);
                if (
                  props.spanishWidgetDataArray[props.addSpanishQuestionIndex]
                ) {
                  props.spanishWidgetDataArray[props.addSpanishQuestionIndex] =
                    questionData;
                  props.setSpanishWidgetDataArray(props.spanishWidgetDataArray);
                } else {
                  props.spanishWidgetDataArray.push(questionData);
                  props.setSpanishWidgetDataArray([
                    ...props.spanishWidgetDataArray,
                  ]);
                }
                if (props.arr.length > 0) {
                  if (props.addSpanishQuestionIndex === props.arr.length)
                    props.setSubTypeChanged(false);
                } else {
                  props.setSubTypeChanged(false);
                }
              } else {
                if (
                  questions[props.addSpanishQuestionIndex] &&
                  !props.spanishWidgetDataArray[props.addSpanishQuestionIndex]
                ) {
                  const itemRef = authorApp.getItem().item.reference;
                  const widgetRef =
                    questions[props.addSpanishQuestionIndex].reference;

                  props.spanishWidgetDataArray[props.addSpanishQuestionIndex] =
                    questions[props.addSpanishQuestionIndex];

                  props.setLoading(false);
                  return await authorApp.navigate(
                    "items/" + itemRef + "/widgets/" + widgetRef + ""
                  );
                } else if (
                  !props.spanishWidgetDataArray[
                    props.addSpanishQuestionIndex
                  ] &&
                  !questions[props.addSpanishQuestionIndex]
                ) {
                  const questionData =
                    props.englishWidgetDataArray[props.addSpanishQuestionIndex];
                  await authorApp.setWidget(questionData, props.payloadLabel);
                  props.spanishWidgetDataArray.push(
                    questions[props.addSpanishQuestionIndex]
                  );
                  props.setSpanishWidgetDataArray([
                    ...props.spanishWidgetDataArray,
                  ]);
                } else if (
                  props.spanishWidgetDataArray[props.addSpanishQuestionIndex]
                ) {
                  const questionData =
                    props.spanishWidgetDataArray[props.addSpanishQuestionIndex];
                  await authorApp.setWidget(questionData, props.payloadLabel);
                }
              }
            }
            props.setLoading(false);
            setTimeout(function () {
              props?.disablePenaltyPoints();
            }, 1000);
          });
          authorApp.on("widgetedit:preview:changed", function (event) {
            const widget = authorApp.getWidget();
            if (props.spanishWidgetDataArray[props.addSpanishQuestionIndex]) {
              props.spanishWidgetDataArray[props.addSpanishQuestionIndex] =
                widget;
              props.setSpanishWidgetDataArray(props.spanishWidgetDataArray);
            } else {
              props.spanishWidgetDataArray.push(widget);
              props.setSpanishWidgetDataArray([
                ...props.spanishWidgetDataArray,
              ]);
            }
            props.setWidgetES(authorApp.getWidget());
            setTimeout(function () {
              props?.disablePenaltyPoints();
            }, 1000);
          });

          if (isFirstCall) {
            setFirstReady(true);
          } else {
            if (index + 1 < props.arr.length) {
              setInitializedIndexes((prev) => [...prev, index + 1]);
            }
          }
        },
      };

      // We init the object
      if (document.getElementById(elementId)) {
        props.setLoading(true);
        const requestES = initRequestES(props.itemRef, "questions");
        getRequest("author", JSON.stringify(requestES)).then((response) => {
          if (response.data && document.getElementById(elementId)) {
            authorApp = window["LearnosityAuthor"]?.init(
              response.data,
              elementId,
              callbacksES
            );
          }
        });
      }
    },
    [props.addSpanishQuestionIndex]
  );

  useEffect(() => {
    initializeLearnosityInstance(`learnosity-authorES`, 0, null, true);
  }, [initializeLearnosityInstance]);

  // useEffect for handling the initialization based on the indexes in the array
  useEffect(() => {
    const lastIndex = initializedIndexes[initializedIndexes.length - 1];
    if (lastIndex !== undefined && lastIndex < props.arr.length) {
      // Call the initialization for the current index
      initializeLearnosityInstance(
        `learnosity-authorES-${lastIndex}`,
        lastIndex,
        new Object(),
        false
      );
    }
  }, [setInitializedIndexes, initializeLearnosityInstance]);

  // Initial call to start the sequence
  useEffect(() => {
    if (firstReady && props.arr.length > 0) {
      setInitializedIndexes([0]); // Start with the first item
    }
  }, [firstReady]);

  return (
    <div>
      <div className="main-content-0">
        <label>Question 1</label>
        <div id="learnosity-authorES"></div>
      </div>
      {props.arr.map((element: number, index) => {
        return (
          <div key={index} className={"main-content-" + element}>
            <label>Question {element + 1}</label>
            <div id={`learnosity-authorES-${index}`}></div>
          </div>
        );
      })}
    </div>
  );
}
